import MainTheme from "@irati/ui/src/global/theme"
import {WellnessCarouselType} from "@irati/types"

const iconBgColor = [
  MainTheme.colors.tertiary.s2_50,
  MainTheme.colors.tertiary.f_50,
  MainTheme.colors.tertiary.i_50,
  MainTheme.colors.tertiary.b_50
]

const selectorBgColor = [
  MainTheme.colors.tertiary.s2_400,
  MainTheme.colors.tertiary.f_400,
  MainTheme.colors.tertiary.i_400,
  MainTheme.colors.tertiary.b_400
]

export const getImageUrlByWidth = (url: string, width: string | number) => {
  const urlArray = url.split("/")
  const uploadIndex = urlArray.findIndex((e) => e === "upload")
  const injectDimensionStr = `w_${width},c_scale`
  urlArray.splice(uploadIndex + 1, 0, injectDimensionStr)
  return urlArray.join("/")
}

export const getIconColor = (id: number) => {
  return iconBgColor[id % iconBgColor.length]
}

export const getSelectorColor = (id: number) => {
  return selectorBgColor[id % selectorBgColor.length]
}

export const getResourceByType = (type: WellnessCarouselType, resource: string) => {
  switch (type) {
    case "media":
      return `/details/${resource}`
    case "category":
      return `/categories/${resource}`
    default:
      return resource
  }
}
